import { queryOptions, useQuery } from "@tanstack/react-query";
import { neWebApi } from "../../../../api";
import { neWebUrls, neWebQueryKeys } from "../../../../ne-web-urls";
import type { PPAInvoiceNumberRange } from "../PPAInvoiceNumberRangesPage.types";

export function useInvoiceNumberRanges() {
  return useQuery(invoiceNumberRangesQueryOptions);
}

const invoiceNumberRangesQueryOptions = queryOptions({
  queryKey: neWebQueryKeys.ppaInvoicing.invoiceNumberRanges(),
  queryFn: () => fetchInvoiceNumberRanges()
});

async function fetchInvoiceNumberRanges() {
  const response = await neWebApi.get<Array<PPAInvoiceNumberRange>>(
    neWebUrls.api.ppaInvoiceNumberRanges()
  );

  return response.data;
}
